import shortid from 'shortid'
import * as api from '../../requests'
import {
  SET_MISC_MY_RECORDS_TEMPLATE,
  SET_MISC_MY_RECORDS_TEMPLATE_LOADING,
  SET_MISC_MY_RECORDS_ITEMS,
  SET_MISC_MY_RECORDS_LOADING,
  SET_MISC_MY_RECORDS_ERROR,
  SET_MISC_MY_RECORDS_LAST_REQUEST_ID,
  SET_MISC_MY_RECORDS_FILTER,
  SET_MISC_MY_RECORDS_ADVANCED_FILTER,
  RESET_MISC_MY_RECORDS_FILTERS,
  SET_MISC_MY_RECORDS_SELECTED_RECORD_ID,
  SET_MISC_MY_RECORDS_DRAWER,
  SET_MISC_MY_RECORDS_DRAWER_LOADING,
  SET_MISC_MY_RECORDS_DRAWER_ERROR,
} from './MiscellaneousMyRecordsReducer'

export const setMiscMyRecordsTemplate = (template) => ({
  type: SET_MISC_MY_RECORDS_TEMPLATE,
  template,
})

export const setMiscMyRecordsTemplateLoading = (loading) => ({
  type: SET_MISC_MY_RECORDS_TEMPLATE_LOADING,
  loading,
})

export const setMiscMyRecordsItems = (items, totalCount) => ({
  type: SET_MISC_MY_RECORDS_ITEMS,
  items,
  totalCount,
})

export const setMiscMyRecordsLoading = (loading) => ({
  type: SET_MISC_MY_RECORDS_LOADING,
  loading,
})

export const setMiscMyRecordsError = (error) => ({
  type: SET_MISC_MY_RECORDS_ERROR,
  error,
})

export const setMiscMyRecordsLastRequestId = (requestId) => ({
  type: SET_MISC_MY_RECORDS_LAST_REQUEST_ID,
  requestId,
})

export const setMiscMyRecordsFilter = (key, value) => ({
  type: SET_MISC_MY_RECORDS_FILTER,
  key,
  value,
})

export const setMiscMyRecordsAdvancedFilter = (fieldName, value) => ({
  type: SET_MISC_MY_RECORDS_ADVANCED_FILTER,
  fieldName,
  value,
})

export const resetMiscMyRecordsFilters = () => ({
  type: RESET_MISC_MY_RECORDS_FILTERS,
})

export const setMiscMyRecordsSelectedRecordId = (recordId) => ({
  type: SET_MISC_MY_RECORDS_SELECTED_RECORD_ID,
  recordId,
})

export const setMiscMyRecordsDrawer = (data) => ({
  type: SET_MISC_MY_RECORDS_DRAWER,
  data,
})

export const setMiscMyRecordsDrawerLoading = (loading) => ({
  type: SET_MISC_MY_RECORDS_DRAWER_LOADING,
  loading,
})

export const setMiscMyRecordsDrawerError = (error) => ({
  type: SET_MISC_MY_RECORDS_DRAWER_ERROR,
  error,
})

export const fetchMiscMyRecordsDrawer = (recordId) => (dispatch) => {
  dispatch(setMiscMyRecordsDrawerLoading(true))
  api.GET_MISC_RECORD_DRAWER(
    recordId,
    (data) => {
      dispatch(setMiscMyRecordsDrawer(data))
    },
    () => {
      dispatch(setMiscMyRecordsDrawerError('Failed to load record details.'))
    }
  )
}

export const fetchMiscMyRecordsTemplate = (moduleId) => (dispatch) => {
  dispatch(setMiscMyRecordsTemplateLoading(true))
  api.GET_MISC_PUBLIC_SEARCH_TEMPLATE(
    moduleId,
    (data) => {
      dispatch(setMiscMyRecordsTemplate(data))
    },
    () => {
      dispatch(setMiscMyRecordsTemplateLoading(false))
    }
  )
}

export const fetchMiscMyRecords = (moduleId) => (dispatch, getState) => {
  dispatch(setMiscMyRecordsLoading(true))

  const { filters } = getState().miscMyRecords
  const requestId = shortid.generate()
  dispatch(setMiscMyRecordsLastRequestId(requestId))

  const parameters = {
    search: filters.search || null,
    registrationDateStart: filters.registrationDateStart || null,
    registrationDateEnd: filters.registrationDateEnd || null,
    ...filters.advancedFilters,
  }

  api.GET_MISC_MY_RECORDS(
    moduleId,
    parameters,
    requestId,
    (data, props) => {
      const safeProps = props || {}
      if (getState().miscMyRecords.lastRequestId === safeProps.requestId) {
        dispatch(setMiscMyRecordsItems(data.Results || [], data.TotalCount || 0))
        dispatch(setMiscMyRecordsLoading(false))
      }
    },
    () => {
      if (getState().miscMyRecords.lastRequestId === requestId) {
        dispatch(setMiscMyRecordsError('Failed to load records.'))
      }
    }
  )
}
